module.exports = __webpack_public_path__ + "img/lb.30cd6fbf.svg";